import classes from "./protein_render.module.css";

export default function ProteinRender() {
  return <div className={classes.proteinRender} />;
}
